import { Action } from '@ngrx/store';
import { PortalRole } from '../../models/portal-role.model';

// load portal roles
export const LOAD_PORTAL_ROLES = '[Portal Roles] Load Portal Roles';
export const LOAD_PORTAL_ROLES_FAIL = '[Portal Roles] Load Portal Roles Fail';
export const LOAD_PORTAL_ROLES_SUCCESS =
  '[Portal Roles] Load Portal Roles Success';
export const CLEAR_PORTAL_ROLES = '[Portal Roles] Clear Portal Roles';

export class LoadPortalRoles implements Action {
  readonly type = LOAD_PORTAL_ROLES;
}

export class LoadPortalRolesFail implements Action {
  readonly type = LOAD_PORTAL_ROLES_FAIL;
  constructor(public payload: any) {}
}

export class LoadPortalRolesSuccess implements Action {
  readonly type = LOAD_PORTAL_ROLES_SUCCESS;
  constructor(public payload: PortalRole[]) {}
}

export class ClearPortalRoles implements Action {
  readonly type = CLEAR_PORTAL_ROLES;
}

// action types
export type PortalRolesAction =
  | LoadPortalRoles
  | LoadPortalRolesFail
  | LoadPortalRolesSuccess
  | ClearPortalRoles;
